import { render, staticRenderFns } from "./phoneSheet.vue?vue&type=template&id=c70d8daa&scoped=true"
import script from "./phoneSheet.vue?vue&type=script&lang=js"
export * from "./phoneSheet.vue?vue&type=script&lang=js"
import style0 from "./phoneSheet.vue?vue&type=style&index=0&id=c70d8daa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c70d8daa",
  null
  
)

export default component.exports